// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"auth_pageWrapper__1gbqJ","logo":"auth_logo__31-_V"};